import sendEvent from './sendEvent';

/**
 * Trigger a logout from a provider authenticated using Adobe Primetime.
 */
export default function logout() {
  sendEvent({
    eventType: 'logout',
  });
  window.AE.logout();
}
